import * as React from "react";

interface Props {
  size?: number;
  color?: string;
}

const ReplaceIconV1 = ({ size = 18, color = "currentColor" }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M4 8h13" />
    <path d="M14 5l3 3-3 3" />
    <path d="M20 16H7" />
    <path d="M10 13l-3 3 3 3" />
  </svg>
);

export default ReplaceIconV1;
